/**
 * Profile route entry — dispatches to the right page for who is looking.
 *
 * Activated talent (legacy 'talent' role, or member with the flag on) →
 * TalentProfile (skills, preferred FA, visibility toggle).
 * Plain member → BasicProfile: identity plus the one switch that activates
 * the talent surface (basic-user split, UAT 2026-09-11). A member should see
 * nothing of skills and availability until they have said they want to.
 * Council/admin → CouncilProfile.
 *
 * Everyone then gets the Emails switches — the landing spot for the link at
 * the foot of every email — and AI access.
 *
 * The sibling files own their layout end-to-end so they can diverge without
 * conditional gating in a single shared file.
 */

import { useEffectiveUser } from '../hooks/useEffectiveUser'
import { BasicProfile } from './profile/BasicProfile'
import { CouncilProfile } from './profile/CouncilProfile'
import { TalentProfile } from './profile/TalentProfile'
import { AIAccessPanel } from '../components/AIAccessPanel'
import { EmailSettings } from '../components/EmailSettings'

export function Profile() {
  const effectiveUser = useEffectiveUser()
  const profile = effectiveUser?.role === 'talent'
    ? <TalentProfile />
    : effectiveUser?.role === 'member'
      ? effectiveUser.talent_profile_active ? <TalentProfile /> : <BasicProfile />
      : <CouncilProfile />
  return (
    <>
      {profile}
      {effectiveUser && <EmailSettings key={`emails-${effectiveUser.id}`} />}
      {effectiveUser && <AIAccessPanel key={effectiveUser.id} />}
    </>
  )
}
